import React from 'react';
import { HStack, VStack, IconButton, Icon, useColorModeValue, Text, Tooltip } from '@chakra-ui/react';
import { Tag as TagIcon, Path as PathIcon } from '@phosphor-icons/react';

const MapLayerToggle = ({ showLabels, onToggleLabels, showSublocations, onToggleSublocations, isMobile }) => {
  const inactiveBg = useColorModeValue('whiteAlpha.900', 'gray.700');
  const activeBg = useColorModeValue('blue.500', 'blue.400');
  const activeColor = 'white';
  const inactiveColor = useColorModeValue('gray.600', 'gray.100');

  if (isMobile) {
    // Mobile: Compact vertical stack of icon-only buttons
    return (
      <VStack
        spacing={1}
        bg={inactiveBg}
        borderRadius="lg"
        p={2}
        boxShadow="lg"
        border="1px"
        borderColor={useColorModeValue('gray.200', 'gray.600')}
        backdropFilter="blur(8px)"
        className="mobile-map-layer-toggle-vertical"
      >
        <Tooltip label="Toggle Labels" placement="right" hasArrow>
          <IconButton
            aria-label="Toggle site labels"
            icon={<Icon as={TagIcon} weight={showLabels ? 'fill' : 'regular'} boxSize={4} />}
            onClick={onToggleLabels}
            bg={showLabels ? activeBg : 'transparent'}
            color={showLabels ? activeColor : inactiveColor}
            size="sm"
            w="32px"
            h="32px"
            minW="32px"
            minH="32px"
            borderRadius="md"
            _hover={{ bg: showLabels ? 'blue.600' : useColorModeValue('gray.100', 'gray.600') }}
            transition="all 0.2s ease-in-out"
          />
        </Tooltip>
        <Tooltip label="Toggle Areas" placement="right" hasArrow>
          <IconButton
            aria-label="Toggle sublocation areas"
            icon={<Icon as={PathIcon} weight={showSublocations ? 'fill' : 'regular'} boxSize={4} />}
            onClick={onToggleSublocations}
            bg={showSublocations ? activeBg : 'transparent'}
            color={showSublocations ? activeColor : inactiveColor}
            size="sm"
            w="32px"
            h="32px"
            minW="32px"
            minH="32px"
            borderRadius="md"
            _hover={{ bg: showSublocations ? 'blue.600' : useColorModeValue('gray.100', 'gray.600') }}
            transition="all 0.2s ease-in-out"
          />
        </Tooltip>
      </VStack>
    );
  }

  // Desktop: Original horizontal layout with text
  return (
    <HStack
      spacing={0}
      bg={inactiveBg}
      borderRadius="lg"
      p="4px"
      boxShadow="lg"
      border="1px"
      borderColor={useColorModeValue('gray.200', 'gray.600')}
      backdropFilter="blur(8px)"
    >
      <IconButton
        aria-label="Toggle site labels"
        icon={<Icon as={TagIcon} weight={showLabels ? 'fill' : 'regular'} boxSize={5} />}
        onClick={onToggleLabels}
        bg={showLabels ? activeBg : 'transparent'}
        color={showLabels ? activeColor : inactiveColor}
        borderRadius="md"
        size="md"
        _hover={{ bg: showLabels ? 'blue.600' : useColorModeValue('gray.100', 'gray.600') }}
        transition="all 0.2s ease-in-out"
        mr={1}
      />
      <Text fontSize="sm" fontWeight="medium" color={inactiveColor} mr={3}>
        Labels
      </Text>
      <IconButton
        aria-label="Toggle sublocation areas"
        icon={<Icon as={PathIcon} weight={showSublocations ? 'fill' : 'regular'} boxSize={5} />}
        onClick={onToggleSublocations}
        bg={showSublocations ? activeBg : 'transparent'}
        color={showSublocations ? activeColor : inactiveColor}
        borderRadius="md"
        size="md"
        _hover={{ bg: showSublocations ? 'blue.600' : useColorModeValue('gray.100', 'gray.600') }}
        transition="all 0.2s ease-in-out"
        mr={1}
      />
      <Text fontSize="sm" fontWeight="medium" color={inactiveColor}>
        Areas
      </Text>
    </HStack>
  );
};

export default MapLayerToggle;
